export default __webpack_public_path__ + "static/media/activecampaign_logo.79d47980.png";